import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

// Todos los catalogos en una sola pestana: con quien se vende, con quien se
// compra y que se vende (articulos con sus clasificaciones y atributos).
const ITEMS = [
  { type: "section", label: "Clientes" },
  { label: "Clientes", icon: "fas fa-user-tie", color: "#f43f5e", bg: "#fff1f2", href: "/Clientes", desc: "Catálogo de clientes", perm: "menu_clientes" },
  { label: "Grupos", icon: "fas fa-users", color: "#14b8a6", bg: "#f0fdfa", href: "/Grupos", desc: "Grupos de clientes", perm: "grupos" },
  { type: "section", label: "Articulos" },
  { label: "Modelos", icon: "fas fa-tshirt", color: "#10b981", bg: "#f0fdf4", href: "/ListadoArticulos", desc: "Alta y edición de artículos", perm: "menu_articulos" },
  { label: "Colores", icon: "fas fa-palette", color: "#14b8a6", bg: "#f0fdfa", href: "/Colores", desc: "Catálogo de colores", perm: "menu_articulos" },
  { label: "Tallas", icon: "fas fa-ruler", color: "#6366f1", bg: "#eef2ff", href: "/Tallas", desc: "Catálogo de tallas", perm: "menu_articulos" },
  { label: "Lineas", icon: "fas fa-bars", color: "#3b82f6", bg: "#eff6ff", href: "/Lineas", desc: "Catálogo de líneas", perm: "menu_articulos" },
  { label: "Marcas", icon: "far fa-copyright", color: "#f59e0b", bg: "#fffbeb", href: "/Marcas", desc: "Catálogo de marcas", perm: "menu_articulos" },
  { label: "Departamentos", icon: "fas fa-users", color: "#8b5cf6", bg: "#f5f3ff", href: "/Familias", desc: "Catálogo de departamentos", perm: "menu_articulos" },
  { label: "Colecciones", icon: "fas fa-calendar-alt", color: "#0ea5e9", bg: "#f0f9ff", href: "/Colecciones", desc: "Catálogo de colecciones", perm: "menu_articulos" },
  { label: "Composiciones", icon: "fas fa-percent", color: "#f43f5e", bg: "#fff1f2", href: "/Composiciones", desc: "Catálogo de composiciones", perm: "menu_articulos" },
  { type: "section", label: "Proveedores" },
  { label: "Proveedores", icon: "fas fa-dolly", color: "#6366f1", bg: "#eef2ff", href: "/Proveedores", desc: "Catálogo de proveedores", perm: "menu_proveedores" },
  { label: "Agentes Aduanales", icon: "fas fa-stamp", color: "#10b981", bg: "#f0fdf4", href: "/ListadoBrokers", desc: "Despacho en aduana", perm: "menu_proveedores" },
  { label: "Forwarders", icon: "fas fa-truck-moving", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoForwarders", desc: "Agentes de carga", perm: "menu_proveedores" },
  { type: "section", label: "Almacenes" },
  { label: "Almacenes", icon: "fas fa-warehouse", color: "#0ea5e9", bg: "#f0f9ff", href: "/Areas", desc: "Áreas y almacenes", perm: "menu_areas" },
  { type: "section", label: "Empresas" },
  { label: "Empresas", icon: "fas fa-industry", color: "#3b82f6", bg: "#eff6ff", href: "/Empresas", desc: "Empresas que facturan y venden", perm: "bancos" },
];

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);
  // se entra si se puede ver alguno de los dos lados
  const puede = !!user.menu_proveedores || !!user.menu_clientes || !!user.grupos || !!user.bancos || !!user.menu_articulos;
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-address-book" color="#0ea5e9" bg="#f0f9ff" title="Catalogos" subtitle="Clientes, articulos, proveedores, almacenes y empresas" />
        {puede ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCatalogos;
